import _ from "underscore"
import {RowType} from "../../reports/table/RowType";

export default class DataTableCreateDefinitionHelper {
    constructor(ddBuilder, tableData, config) {
        this.ddBuilder = ddBuilder;
        this.tableData = tableData;
        this.config = config;

        this.labels = {
            titleMessage: "hello"
        };
    }

    createTable() {
        var rows = [];
        var rowTypes = RowType;

        var rowStrategies = {};
        rowStrategies[rowTypes.HEADER] = _.bind(this.makeHeader, this);
        rowStrategies[rowTypes.TOTALS] = _.bind(this.makeTotals, this);
        rowStrategies[rowTypes.FIRST_LEVEL] = _.bind(this.makeRow, this, 0);
        rowStrategies[rowTypes.SECOND_LEVEL] = _.bind(this.makeRow, this, 1);
        rowStrategies[rowTypes.THIRD_LEVEL] = _.bind(this.makeRow, this, 2);
        rowStrategies[rowTypes.FORTH_LEVEL] = _.bind(this.makeRow, this, 3);

        var headerData = this.tableData[0];
        var headerDefinition = rowStrategies[headerData.type](headerData);

        for (var i = 1; i < this.tableData.length; i++) {
            var rowData = this.tableData[i];
            var rowDefinition = rowStrategies[rowData.type](rowData);
            rows.push(rowDefinition);
        }

        this.ddBuilder.addDataTable(headerDefinition, rows);
    }

    makeHeader(row) {
        return this.ddBuilder.createHeaderDataRow(row);
    }

    makeTotals(row) {
        return this.ddBuilder.createTotalsRow(row);
    }

    makeRow(lvl, row) {
        return this.ddBuilder.createRow(lvl, row);
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/leavesReport/DataTableCreateDefinitionHelper.js